/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {useReservationStatusForLogin} from "utils/reservationUtils";
import {Reservation} from "types/entities/Reservation";
import {Link} from "react-router-dom";

interface BookingLoginTableRowColumnResponsiveProps {
    reservation: Reservation;
    label?: string;
    isNotDisabled?: boolean | undefined;
    link?: string;
}

// export const BookingLoginTableRowLinkButton = (props: {value: boolean; label?: string}) => {
//     return (
//         <div
//             className={clsx(
//                 "rounded-b-md md:rounded-md md:px-2 py-3 md:py-0.5 border border-blue-500 bg-blue-500 active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 text-white flex w-full md:w-auto items-center text-center justify-center md:text-sm leading-6 font-bold cursor-pointer",
//                 !props.value && "bg-opacity-50 opacity-50 border-opacity-50 !text-black grayscale cursor-not-allowed pointer-events-none select-none"
//             )}
//         >
//             <AdjustmentsHorizontalIcon className={clsx("w-5 h-5", props.label && "mr-1.5")} />
//             {props?.label && <span>{props.label}</span>}
//         </div>
//     );
// };
export const BookingLoginTableRowLinkButton = (props: {value: boolean; label?: string}) => {
    return (
        <div
            className={clsx(
                // "rounded-b-md md:rounded-md md:px-2 py-3 md:py-0.5 border border-blue-500 bg-blue-500 active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 text-white flex w-full md:w-auto items-center text-center justify-center md:text-sm leading-6 font-bold cursor-pointer",
                // !props.value && "bg-opacity-50 opacity-50 border-opacity-50 !text-black grayscale cursor-not-allowed pointer-events-none select-none"
                "font-bold text-base md:text-[20px] inline-flex items-center text-center w-auto gap-2 transform-gpu duration-150 transition-all cursor-pointer text-white hover:text-white rounded-xl px-5 py-3 bg-gradient-arboYellowOrange hover:brightness-90"
            )}
        >
            {/*<AdjustmentsHorizontalIcon className={clsx("w-5 h-5", props.label && "mr-1.5")} />*/}
            {props?.label && <span>{props.label}</span>}
        </div>
    );
};

const BookingLoginTableRowLink = (props: BookingLoginTableRowColumnResponsiveProps) => {
    const {t} = useTranslation();
    const {getStatus} = useReservationStatusForLogin();

    const reservationStatus = getStatus(props.reservation);

    if (!props?.isNotDisabled && !reservationStatus.value) {
        return (
            <BookingLoginTableRowLinkButton
                label={props?.label ? props.label : reservationStatus.label}
                value={props?.isNotDisabled ? props.isNotDisabled : reservationStatus.value}
            />
        );
    }

    if (!reservationStatus.value) {
        return (
            <div>{props?.label ? props.label : reservationStatus.label}</div>
        )
    }

    return (
        <>
            <Link to={(props?.link ? props.link : "/booking/login/reservations/detail/") + props.reservation.id}>
                <BookingLoginTableRowLinkButton
                    label={props?.label ? props.label : reservationStatus.label}
                    value={props?.isNotDisabled ? props.isNotDisabled : reservationStatus.value}
                />
            </Link>
        </>
    );
};

export default BookingLoginTableRowLink;
